import React, {useState} from "react"
import styled from "styled-components"

const DataTableRow = (props) => {
  const [isExpanded, toggleIsExpanded] = useState(false)

  return (
    <OuterDiv>
      {props.rows && isExpanded && (
        <>
          {props.rows.map((rowChild, rowChildKey) => {
            return (
              <DataTableRow
                align={props.align}
                cells={rowChild.cells}
                columns={props.columns}
                firstColumnWidth={props.firstColumnWidth}
                key={rowChildKey}
                name={rowChild.name}
                renderCell={props.renderCell}
                striped={props.striped}
              />
            )
          })}
        </>
      )}
      <RowDiv bold={props.bold} striped={props.striped}>
        <RowNameDiv firstColumnWidth={props.firstColumnWidth}>
          {props.rows && (
            <ExpandButtonDiv
              isExpanded={isExpanded}
              onClick={() => toggleIsExpanded(!isExpanded)}
            >
              {isExpanded ? "-" : "+"}
            </ExpandButtonDiv>
          )}
          {props.name}
        </RowNameDiv>
        <CellsDiv>
          {props.columns.map((column, columnKey) => {
            return (
              <CellDiv
                align={props.align}
                key={columnKey}
                numberOfColumns={props.columns.length}
              >
                {props.renderCell(props.cells[column.code], columnKey)}
              </CellDiv>
            )
          })}
        </CellsDiv>
      </RowDiv>
    </OuterDiv>
  )
}

const CellDiv = styled.div`
  padding: 0.5em 1em;
  text-align: ${(props) => props.align};
  width: ${(props) => 100 / props.numberOfColumns}%;
  width: 13.3%;
`

const CellsDiv = styled.div`
  display: flex;
  flex-grow: 1;
`

const ExpandButtonDiv = styled.div`
  border: 1px solid ${(props) => (props.isExpanded ? "#333" : "#999")};
  color: ${(props) => (props.isExpanded ? "#333" : "#999")};
  cursor: pointer;
  height: 1em;
  left: 0.5em;
  line-height: 0.7em;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  width: 1em;
  &:hover {
    border-color: #333;
    color: #333;
  }
`

const OuterDiv = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.borderColorLight};
  border-top: 0;
`

const RowDiv = styled.div`
  background-color: ${(props) => props.striped && "rgba(0, 0, 0, 0.03)"};
  display: flex;
  font-weight: ${(props) => props.bold && "bold"};
`

const RowNameDiv = styled.div`
  padding: 0.5em 0.5em 0.5em 2em;
  position: relative;
  width: ${(props) => props.firstColumnWidth};
`

DataTableRow.defaultProps = {
  bold: false,
  cells: {},
  renderValue: (value) => value,
}

export {DataTableRow}
